import * as styles from "@/styles/modules/DefaultImage.module.scss"

export type Category =
  | "Discussions"
  | "Hot Corner"
  | "Polls"
  | "Positive"
  | "By the Numbers"
  | "Trivia"
  | "The Weird Wide World"
  | "Sprinkles"
interface DefaultImageProps {
  category: Category
}

interface CategoryConfig {
  emoji: string
  backgroundColor: string
  title?: string
}

const categoryConfig: Record<Category, CategoryConfig> = {
  Discussions: {
    emoji: "💬",
    backgroundColor: "#ECD3F9",
  },
  "Hot Corner": {
    emoji: "🔥",
    backgroundColor: "#FFE7CF",
  },
  Polls: {
    emoji: "🙋",
    backgroundColor: "#F9F3D3",
  },
  Positive: {
    emoji: "🤗",
    backgroundColor: "#FEDBEE",
  },
  "By the Numbers": {
    emoji: "📊",
    backgroundColor: "#CEEFFF",
  },
  Trivia: {
    emoji: "❓",
    backgroundColor: "#FBD8DF",
  },
  "The Weird Wide World": {
    emoji: "👽",
    backgroundColor: "#E4FDDC",
  },
  Sprinkles: {
    emoji: "💬",
    backgroundColor: "#EBF8FF",
    title: "Daily Sprinkle",
  },
}

export default function DefaultImage({ category }: DefaultImageProps) {
  const config = categoryConfig[category]

  if (!config) {
    return null
  }

  return (
    <div
      className={styles.wrapper}
      style={{ backgroundColor: config.backgroundColor }}
    >
      <h3 className={styles.title}>
        <span className={styles.emoji}>{config.emoji}</span>
        {config.title || category}
      </h3>
    </div>
  )
}
